module.exports = __webpack_public_path__ + "static/media/lave-vaisselle.1bb15d06.svg";